module.exports = __webpack_public_path__ + "img/iconwenhao.4a5a8fb2.png";